import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getCarousel, updateCarousel } from '../actions/CarouselActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import CarouselForm from '../components/CarouselForm';

import Configuration from '../Config';

const validation = Configuration.Validations.carousel;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class EditCarousel extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    componentDidMount() {
        this.props.dispatch(getCarousel(this.id));
    }

    handleSave = (values) => {
        this.props.dispatch(updateCarousel(this.props.carousel.id, values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/carousel">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista carusel
                            </Button>
                        </Link>
                    </Pane>

                    <Pane marginLeft={16}>
                        <Link to={`/carousel/${this.id}`}>
                            <Button iconBefore="cross" intent="warning">
                                Anuleaza modificarile
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modificare Slide Carusel
                    </Heading>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <CarouselForm
                            isEdit={true}
                            initialValues={this.props.carousel}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.carousel.errors.type === 'validation' ? mapValidationErrors(state.carousel.errors.fields): [],
        carousel: state.carousel.current
    }
}

export default connect(mapStateToProps)(EditCarousel);
